"use client";

import React from "react";
import Link from "next/link";
import "./style.css";
import { Post } from "@/types/post.types";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface BreakingNewsProps {
  news: Post[];
}

const ensureAbsolute = (url?: string) => {
  if (!url || url === "location not found") return "/";
  if (url.startsWith("/") || url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `/${url}`;
};

export default function ScamNews({ news }: BreakingNewsProps) {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isDark = resolvedTheme === "dark";

  return (
    <div
      className="scam-news-section"
      style={{
        backgroundColor: isDark ? "#343435" : "#ffffff",
      }}
    >
      {/* MARQUEE */}
      <div className="header-bar">
        <div className="marquee-continuous">
          <div className="marquee-content">
            {Array(10)
              .fill("SCAM ALERT -")
              .map((text, idx) => (
                <span key={idx}>{text}</span>
              ))}
          </div>
        </div>
      </div>

      <div className="timeline-container">
        <div className="timeline-line"></div>
        <div className="timeline-wrapper">
          {news.map((item) => (
            <div className="news-item" key={item.id}>
              <div className="timeline-row">
                {/* DOT */}
                <div className="dot"></div>
                {/* CATEGORY */}
                {item.category_name && (
                  <Link href={ensureAbsolute(item.category_slug)}>
                    <span
                      className="badge gh-tag me-2"
                      style={
                        {
                          "--accent": item.category_color ?? "#00897B",
                          background: item.category_color
                            ? `color-mix(in srgb, ${item.category_color} 80%, transparent)`
                            : "#00897B",
                          color: "#ffffff",
                        } as React.CSSProperties
                      }
                    >
                      {item.category_name}
                    </span>
                  </Link>
                )}

                {item.sub_category_name && (
                  <Link href={ensureAbsolute(item.sub_category_slug)}>
                    <span
                      className="badge gh-tag"
                      style={
                        {
                          "--accent": item.sub_category_color ?? "#00897B",
                          background: item.sub_category_color
                            ? `color-mix(in srgb, ${item.sub_category_color} 80%, transparent)`
                            : "#00897B",
                          color: "#ffffff",
                        } as React.CSSProperties
                      }
                    >
                      {item.sub_category_name}
                    </span>
                  </Link>
                )}
              </div>

              {/* DATE */}
              <span className="date">
                <time
                  dateTime={item.date}
                  style={{
                    color: "rgba(136, 136, 136, 0.7)",
                  }}
                >
                  {new Date(item.date).toLocaleString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </time>
              </span>

              {/* TITLE */}
              <h4
                className="gh-sidebar-feat-post-title"
                style={{
                  color: isDark ? "#e5e5e5" : "#222",
                }}
              >
                <Link href={item.title_slug}>{item.title}</Link>
              </h4>

              {/* DESCRIPTION */}
              <p
                className="description"
                style={{
                  color: isDark ? "#e5e5e5" : "#222",
                }}
              >
                {item.summary}
              </p>

              {/* READ MORE */}
              <Link
                href={`/${item.title_slug}`}
                className="read-more"
                aria-label={`Read more about ${item.title}`}
              >
                <span className="fw-bolder">
                  Read more
                  <span className="visually-hidden">
                    {" "}
                    about {item.title_slug || item.title_slug}
                  </span>
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* VIEW ALL BUTTON */}
      <Link
        href="/scam"
        className="gh-main-button-spam"
        aria-label="View all scams"
      >
        View all Scams
      </Link>
    </div>
  );
}
